// extracted by mini-css-extract-plugin
export default {"wrap":"g70pHaHWx149DyzdKiQF","icon":"_U9jPvS8T15QtuwbolZP","copy":"tMZgvDZyJ66yVEYstYPw","back":"e2U8e7nPHJONOsP9b8zF"};